<template>
  <Html :lang="head.htmlAttrs?.lang" :dir="head.htmlAttrs?.dir">
    <Head>
      <template v-for="link in head.link" :key="link.id">
        <Link
          :id="link.id"
          :rel="link.rel"
          :href="link.href"
          :hreflang="link.hreflang"
        />
      </template>
      <template v-for="meta in head.meta" :key="meta.id">
        <Meta :id="meta.id" :property="meta.property" :content="meta.content" />
      </template>
    </Head>
    <Body>
      <div class="page-wrapper">
        <NuxtLazyHydrate v-if="!isMenuHidden" when-idle>
          <NavigationHeader />
        </NuxtLazyHydrate>
        <main class="main-content">
          <slot />
        </main>
        <NuxtLazyHydrate v-if="!isFooterHidden" when-visible>
          <NavigationFooter />
        </NuxtLazyHydrate>
      </div>
    </Body>
  </Html>
</template>

<script lang="ts" setup>
import { MAIN_CONTENT_MARGIN_TOP_WITHOUT_BREADCRUMBS } from '~/constants/main-content-margin-top-without-breadcrumbs'

const props = defineProps<{
  isMenuHidden?: boolean
  isFooterHidden?: boolean
  shouldAddMarginTopIntoMainContent?: boolean
}>()

const mainContentMarginTop = computed(() =>
  props.shouldAddMarginTopIntoMainContent
    ? MAIN_CONTENT_MARGIN_TOP_WITHOUT_BREADCRUMBS
    : '0'
)

useIsMobile()
useA11y()

const head = useLocaleHead({
  addDirAttribute: true,
  identifierAttribute: 'key',
  addSeoAttributes: true
})
</script>

<style lang="scss">
.main-content {
  transition: opacity $transition;

  .route-change & {
    opacity: 0;
  }

  body:not(.route-change) & {
    opacity: 1;
  }
}
</style>

<style lang="scss" scoped>
.main-content {
  position: relative;
  margin-top: v-bind(mainContentMarginTop);
  filter: none;

  &::after {
    @include fill-space;
    z-index: 2;
    pointer-events: none;
    content: '';
    background: linear-gradient(
      0deg,
      rgba($navy-blue-500, 0.05),
      rgba($navy-blue-500, 0.05)
    );
    background-blend-mode: multiply, normal;
    backdrop-filter: blur(4px);
    opacity: 0;
    transition: opacity $transition;
  }

  &--blurred::after {
    opacity: 1;
  }
}
</style>
